<template>
  <div class="container">
        <img src="static/img/mainImg.jpg">
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {

    }
  }
}
</script>

<style scoped>
.container{
  width: 100%;
}
.container img{
  width: 100%;
  margin-bottom: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue